import { useEffect } from 'react';
import { useGenerateSession } from '@/services/useGenerateSession';
import { getCookie } from '@/utils/functions';
import { loadFromStorage } from '@/utils/client-storage/localStorage';

export const SessionInitializer = ({ utmTags }: { utmTags: string }) => {
  const { mutate } = useGenerateSession();

  useEffect(() => {
    const currentId = getCookie('currentId') || loadFromStorage('currentId');
    if (!currentId) {
      mutate({ utmTags });
    }
  }, [mutate, utmTags]);

  return null;
};
